import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import { usePopper } from 'react-popper';
export default function Dropdown({ open, label, children, onClick, isPortal, minWidth }) {
    const [referenceElement, setReferenceElement] = useState(null);
    return (React.createElement("div", { className: "dropdown" },
        React.createElement("button", { className: 'btn btn-black', ref: setReferenceElement, onClick: onClick, type: "button", "aria-expanded": open },
            label,
            React.createElement("i", { className: "fas fa-chevron-down", style: { marginLeft: '.5em' } })),
        !isPortal && open && React.createElement(DropdownMenu, { referenceElement: referenceElement, minWidth: minWidth }, children),
        isPortal && open && React.createElement(DropdownMenuPortal, { referenceElement: referenceElement, minWidth: minWidth }, children)));
}
export function DropdownMenu({ referenceElement, children, minWidth }) {
    const [popperElement, setPopperElement] = useState(null);
    const { styles, attributes } = usePopper(referenceElement, popperElement);
    return (React.createElement("div", Object.assign({ ref: setPopperElement }, attributes.popper, { style: Object.assign(Object.assign({}, styles.popper), { minWidth }), className: 'dropdown-menu' }), children));
}
export function DropdownMenuPortal({ referenceElement, children, minWidth }) {
    const [popperElement, setPopperElement] = useState(null);
    const { styles, attributes } = usePopper(referenceElement, popperElement);
    let portalEl = document.getElementById('ltg-dd-portal-el');
    if (!portalEl) {
        portalEl = document.createElement('div');
        portalEl.setAttribute('id', 'ltg-dd-portal-el');
        document.body.appendChild(portalEl);
    }
    return createPortal(React.createElement("div", Object.assign({ ref: setPopperElement }, attributes.popper, { style: Object.assign(Object.assign({}, styles.popper), { minWidth }), className: 'dropdown-menu' }), children), portalEl);
}
